import api from './serviceApi'; // Import the axios instance

const serviceOrderApi = {
    /**
     * Fetch a specific service entry by its ID.
     * @param {number} id - The ID of the service entry.
     * @returns {Promise<Object>} - The service entry data.
     */
    requestService: async () => {
        try {
            const response = await api.post(`/Service`);
            return response.data;
        } catch (error) {
            console.error('Error fetching service by ID:', error);
            throw error;
        }
    },

    /**
     * Fetch a paginated list of service entries with optional filters.
     * @param {Object} params - Query parameters such as `page`, `quantity`, `term`, `orderBy`, `include`.
     * @returns {Promise<Object>} - The paginated list of service entries.
     */
    getservicePaginated: async (params) => {
        try {
            const response = await api.get('/Service/pagged', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching paginated service entries:', error);
            throw error;
        }
    },

    /**
     * Export customers based on filters.
     * @param {Object} params - Query parameters such as `term`, `isActive`, etc.
     * @returns {Promise<Blob>} - The exported file data.
     */
    exportLogs: async (params) => {
        try {
            const response = await api.get('/Service/export', {
                params
            });
            return response.data;
        } catch (error) {
            console.error('Error exporting customers:', error);
            throw error;
        }
    },
};

export default serviceOrderApi;
